import { css } from 'styled-components';

const megaLarge = () => css`
  height: 148px;
  padding: 16px 16px;
`;

export { megaLarge };
